import axios from 'axios'
import getLanguage from "./getLanguage"
import getCoupon from "./getCoupon"

// **************************************************
// ******************** USER API ********************
// **************************************************

export const getSubscriptionStatus = async (token) => {
    const queryParams = Buffer.from(JSON.stringify({token: token, p: 1})).toString('base64')
    const url = `${process.env['REACT_APP_USER_API']}/subscription/status?p=${queryParams}`

    try {
        const result = await axios.get(url)
        return result.data
    } catch (err) {
        console.error(url, err)
        return {success: false}
    }
}

export const getUserData = async (token) => {
    const queryParams = Buffer.from(JSON.stringify({token: token, p: 1})).toString('base64')
    const url = `${process.env['REACT_APP_USER_API']}?p=${queryParams}`

    try {
        const result = await axios.get(url)
        return result.data
    } catch (err) {
        console.error(url, err)
        return {success: false}
    }
}

export const updateIntegrations = async (token) => {
    const params = new URLSearchParams()
    params.append('token', token)

    const url = `${process.env['REACT_APP_USER_API']}/integrations?p=1`

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }

    return await axios.put(url, params, config)
}

// Would make more sense by using navigator.sendBeacon() but it would only support POSTs
export const updateIntegrationsWithNoResponse = async (token) => {
    const params = new URLSearchParams()
    params.append('token', token)

    const url = `${process.env['REACT_APP_USER_API']}/integrations?p=1`

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }

    const request = axios.put(url, params, config)

    await Promise.race([
        request.catch(() => {}),
        new Promise(resolve => setTimeout(resolve, 200))
    ]);
}

export const deleteAccount = async (token) => {
    const url = `${process.env['REACT_APP_USER_API']}/?lang=${getLanguage()}&token=${token}&p=1`
    return await axios.delete(url)
}

// ****************************************************
// ******************** STRIPE API ********************
// ****************************************************

export const createStripeIntent = async (token, origin) => {
    const intentPostPayload = {
        token: token,
        origin: origin
    }

    return await axios.post(`${process.env['REACT_APP_STRIPE_API_ENDPOINT']}/subscription/intent`, intentPostPayload)
}

export const createStripeSubscriptionFromIntent = async (token, customerID, paymentMethodID, priceID) => {
    const createSubscriptionPostPayload = {
        token: token,
        customerID: customerID,
        paymentMethodID: paymentMethodID,
        priceID: priceID
    }

    return await axios.post(`${process.env['REACT_APP_STRIPE_API_ENDPOINT']}/subscription/create`, createSubscriptionPostPayload)
}

export const cancelStripeSubscription = async (subscriptionID) => {
    const cancelSubscriptionPostPayload = {
        subscriptionID: subscriptionID
    }

    return await axios.post(`${process.env['REACT_APP_STRIPE_API_ENDPOINT']}/subscription/cancel`, cancelSubscriptionPostPayload)
}

export const createStripePurchaseSession = async (userID) => {
    const purchaseSessionPostPayload = {
        userID: userID,
        lang: getLanguage(),
        coupon: getCoupon()
    }

    return await axios.post(`${process.env['REACT_APP_STRIPE_API_ENDPOINT']}/subscription/purchaseSession`, purchaseSessionPostPayload)
}

export const createStripeManageSession = async (stripeCustomerID) => {
    const purchaseSessionPostPayload = {
        customerID: stripeCustomerID,
        lang: getLanguage()
    }

    return await axios.post(`${process.env['REACT_APP_STRIPE_API_ENDPOINT']}/subscription/manage`, purchaseSessionPostPayload)
}

// ********************************************************
// ******************** SCHOOLZONE API ********************
// ********************************************************

// TODO schoolzone calls should be moved here

